import { render, staticRenderFns } from "./regAnkang.vue?vue&type=template&id=645ad8e7&scoped=true&"
import script from "./regAnkang.vue?vue&type=script&lang=js&"
export * from "./regAnkang.vue?vue&type=script&lang=js&"
import style0 from "./regAnkang.vue?vue&type=style&index=0&lang=css&"
import style1 from "./regAnkang.vue?vue&type=style&index=1&id=645ad8e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645ad8e7",
  null
  
)

export default component.exports